<template>
    <div>
        <p>Are you sure you want to pick <strong>{{versionLabel}}</strong> as the winner and finish the split test? This will discard the other versions.</p>
    </div>
</template>

<script>
    export default {
        name: 'confirm-winner-step',
        inject: ['registerAction', 'stepKey', 'getContext'],
        props: {
            attributeName: {
                type: String,
                required: true,
            },
            previousAttributeName: String,
            versions: Array,
            useName: Boolean,
        },
        computed: {
            versionLabel() {
                const index = this.getContext().formData[this.previousAttributeName];
                if (this.useName) {
                    return this.versions[index].name;
                }
                return `Version ${index + 1}`;
            },
        },
        methods: {
            register() {
                const action = {
                    attributeName: this.attributeName,
                    delegated: () => true,
                };
                this.registerAction(this.stepKey, action);
            },
        },
        mounted() {
            this.register();
        },
    };
</script>
